import axios from './axios'
import { handleSuccess, handleError } from './axiosHandler'
import { headerJson, authHeader, authHeaderJson } from '../_helpers/auth-header'

import { config } from '../config'
const base_url = config.apiUrl

const model = 'Member/'

export const memberService = {
  getAll,
  getById,
  getByNationalCode,
  add,
  addFromAdmin,
  edit,
  delete: _delete,
  transferToBank,
  changeMemberStatus,
  ExportToCsv,
  License,
  printLicence,
  PrintAllLicenses,
  addToOtaghIran
}
function getAll(dto) {
  const url = base_url + model + 'GetAll'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function addToOtaghIran(dto) {
  const url = base_url + model + 'PostToOtaghIran'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getById(id) {
  const url = base_url + model + 'getById/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getByNationalCode(nationalCode) {
  const url = base_url + model + 'getByNationalCode/' + nationalCode
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(dto) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: headerJson() })
}

function addFromAdmin(dto) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function edit(dto) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, dto, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}

function transferToBank(nationalCode, unionId) {
  const url =
    base_url + model + 'transferToBank/' + nationalCode + '/' + unionId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function changeMemberStatus(dto) {
  const url = base_url + model + 'changeMemberStatus'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function ExportToCsv(dto) {
  const url = base_url + model + 'ExportToCsv'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function License(dto) {
  const url = base_url + 'License'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function printLicence(memberId, trackId) {
  const url = config.apiBaseUrl + 'print/license/' + memberId
  console.log(url)

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url)
}

function PrintAllLicenses(dto) {
  const url = config.apiBaseUrl + 'Print/AllLicense'
  // console.log(url);

  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}
